var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-3"},[_c('v-card-title',[_vm._v(_vm._s(_vm.reply.field.title))]),_c('v-card-subtitle',[_vm._v(_vm._s(_vm.reply.field.description))]),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.reply.field.html.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }